export const OpeningHours = {
    Phone: "09.00-15.00",
    Chat: {
        MonFri: "09.00-21.00",
        SunSat: "09.00-16.00"
    }
}

export const PhoneNumbers = {
    Default: "88772000",
    Contact: {
        Desktop: "70604552",
        Mobile: "30202580",
    },
    Raffle: "70604687",
}

export interface CallMePhoneNumberSet {
    primary: string
    secondary?: string
}

export type CallMePhoneNumberVariant = 'Default' | 'Broadband' | 'Contact' | 'OrderFlow' | 'WifiMesh'

export const CallMePhoneNumbers: Record<CallMePhoneNumberVariant, CallMePhoneNumberSet> = {
    Default: {
        primary: '88772019',
    },
    Broadband: {
        primary: '88772019',
        secondary: '61404260',
    },
    Contact: {
        primary: '70604552',
        secondary: '30202580',
    },
    OrderFlow: {
        primary: '92909474',
        secondary: '93405530',
    },
    WifiMesh: {
        primary: '92901980',
    }
}
